module.exports = __webpack_public_path__ + "static/media/wizards-new.8e9f708c.svg";